import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { ModalController } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-partner-sidebar',
  templateUrl: './partner-sidebar.component.html',
  styleUrls: ['./partner-sidebar.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class SidebarPartnershipsComponent implements OnInit {
  faCircle = faCircle;
  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {/* empty */}

  dismiss() { this.modalCtrl.dismiss(); }

}
